import type { PlaceModelSpec } from '@elara/domain/models/PlaceModelSpec';

import type { PlacesContainer } from '#containers/PlacesContainer.js';
import type { ClientDocumentHandle } from '#firebase/types.js';
import type { Place } from '#models/PlaceModel.js';

import { getErrorReporter } from '#lib/error-reporting.js';
import { createState } from '#lib/signals-utils.js';
import { parseDocumentId } from '#lib/utils.js';

export function createPlaceGuideState(places: PlacesContainer) {
  const state = createState({
    handle: undefined as ClientDocumentHandle<PlaceModelSpec> | undefined,

    get place(): Place | undefined {
      return this.handle?.data as Place | undefined;
    },

    get isLoading(): boolean {
      return !(this.handle?.isReady ?? false);
    },

    /** Finds a place by its Firestore document ID */
    findPlace(placeId: string) {
      try {
        const id = parseDocumentId(placeId) ?? placeId;
        this.handle = places.ClientPlace.get({ id });
      } catch (error) {
        getErrorReporter().captureException(error);
        throw error;
      }
    },

    /** Resets the state */
    reset() {
      this.handle = undefined;
    },
  });

  return state;
}

/** The main reactive store for place guide functionality. */
export type PlaceGuideState = ReturnType<typeof createPlaceGuideState>;
